import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { ArchiveOutlined } from '@mui/icons-material';

export const ArchiveButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<ArchiveOutlined />} {...props}>
      {children ?? t('Archive')}
    </Button>
  );
};
